import $ from "jquery";
const html = document.querySelector("html");
const SiteHeaderMobile = {
    init: () => {
        const siteHeaderMobile = document.querySelector(".site-header-mobile");
        if (siteHeaderMobile === null)
            return;
        const navItems = siteHeaderMobile.querySelectorAll(".nav-item");
        navItems.forEach((element) => {
            const btnExpand = element.querySelector("i");
            const navSubMenuToggler = element.querySelector('.nav-submenu-toggler');
            if (navSubMenuToggler) {
                navSubMenuToggler.addEventListener("click", SiteHeaderMobile.toggleSubmenu.bind(this, element));
            }
            if (btnExpand) {
                btnExpand.addEventListener("click", SiteHeaderMobile.toggleSubmenu.bind(this, element));
            }
        });
        SiteHeaderMobile.toggle();
        SiteHeaderMobile.activeSecondLevel(siteHeaderMobile);
        SiteHeaderMobile.activeThirdLevel(siteHeaderMobile);
    },
    activeSecondLevel: (siteHeaderMobile) => {
        const $menulv2 = $(siteHeaderMobile).find('.megamenu-level2');
        const { origin, pathname, hash } = window.location;
        $menulv2.each((menulv2Index, menu) => {
            const $navLinks = $(menu).find('a');
            $navLinks.each((navLinkIndex, navLink) => {
                const linkHref = $(navLink).attr('href');
                const linkPathname = linkHref.replace(origin, '').replace(`/${hash}`, '');
                const linkHash = (linkHref.includes('#')) ? linkHref.replace(origin, '').split('#')[1] : '';
                if (linkPathname === pathname && linkHash && hash) {
                    $menulv2.parent('.nav-item').addClass('is-active');
                    $(navLink).parent('.nav-item').addClass('is-current');
                    $(menu).css({
                        display: 'block'
                    });
                }
            });
        });
        $(siteHeaderMobile).find('.megamenu-level2 a').on('click', (event) => {
            const anchorTarget = event.currentTarget;
            const target = event.target;
            const [, hash] = $(anchorTarget).attr('href').split('#');
            if (hash && target.tagName !== "I") {
                const $bsTarget = document.querySelector(`[data-bs-target="#${hash}"]`);
                if ($bsTarget) {
                    event.preventDefault();
                    const siteHeaderMobile = document.querySelector(".site-header-mobile");
                    siteHeaderMobile.classList.remove("is-active");
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 0);
                    $bsTarget.click();
                }
            }
        });
    },
    activeThirdLevel: (siteHeaderMobile) => {
        const $menulv3 = $(siteHeaderMobile).find('.megamenu-level3');
        $menulv3.each((menulv3Index, menu) => {
            const $navLinks = $(menu).find('a');
            $navLinks.each((navLinkIndex, navLink) => {
                if ($(navLink).hasClass('is-active')) {
                    const $navItem = $(menu).parents('.nav-item');
                    const $menuLv2 = $(navLink).parents('.megamenu-level2');
                    $(menu).css({ 'display': 'block' });
                    $navItem.addClass('is-current').addClass('is-active');
                    $menuLv2.css({ 'display': 'block' });
                }
            });
        });
    },
    toggleSubmenu: (element) => {
        const submenu = element.querySelector(".submenu");
        $(submenu).parents(".nav-item").siblings().removeClass("is-active");
        $(element).toggleClass("is-active");
        $(submenu).parents(".nav-item").siblings().find(".submenu").slideUp();
        $(submenu).slideToggle();
        event.preventDefault();
    },
    toggle: () => {
        const navTogglers = document.querySelectorAll(".navbar-toggler");
        const siteHeaderMobile = document.querySelector(".site-header-mobile");
        navTogglers.forEach((button) => {
            button.addEventListener("click", (event) => {
                siteHeaderMobile.classList.toggle("is-active");
                html.classList.toggle("is-fixed");
                event.preventDefault();
            });
        });
    },
};
export default SiteHeaderMobile;
